import { render, staticRenderFns } from "./OrderWorklogsListDate.vue?vue&type=template&id=2216bdbc&"
import script from "./OrderWorklogsListDate.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OrderWorklogsListDate.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports